import Micromodal from 'micromodal';
import Handlebars from 'handlebars';
const ModalIdString = 'modal-leadership-popup';

const ModalDestinationContainer = 'modal-leadership-popup-container';
const ModalProjectsDestinationContainer = 'modal-projects-popup-container';
const ModalTriggerClass = 'tile-modal-trigger';
let lastFocusedElement;

/**
 * Open modal
 *
 * @returns {boolean}
 */
const tryToggleModal = (modal_id = ModalIdString) => {
  lastFocusedElement = document.activeElement;

  if (!document.getElementById(modal_id)) {
    console.warn('Missing modal container id');
    return false;
  }

  Micromodal.show(modal_id, {
    disableScroll: true,
    onShow: modal => {
      // console.log(modal, 'modal');
    },
    onClose: () => {
      try {
        lastFocusedElement.blur();
      } catch (e) {
        console.warn(e);
      }
    }
  });
};

/**
 *
 * @param {HTMLDivElement} paragraph_element
 */
const processParagraph = paragraph_element => {
  paragraph_element.classList.toggle('is-processed');
};

/**
 *
 * @param {HTMLDivElement} paragraph_element
 * @returns {HTMLLinkElement}
 */
const findTrigger = paragraph_element => {
  return paragraph_element.querySelector(`.${ModalTriggerClass}`);
};

/**
 *
 * @param {DOMTokenList} classes
 * @returns {*}
 */
function extractParagraphId(classes) {
  const paragraph_id_class = Array.from(classes).find(class_name => class_name.match(/\d+/));
  return paragraph_id_class.match(/\d+/)[0];
}

const paragraphs = document.querySelectorAll('.paragraph--type--leadership-content');
const projectPanels = document.querySelectorAll('.node--type--project');

if (projectPanels) {
  Array.from(projectPanels).forEach(element => {
    const triggerElem = findTrigger(element);

    if (!triggerElem) {
      return false;
    }

    triggerElem.addEventListener('click', event => {
      let paragraph_id = extractParagraphId(triggerElem.parentElement.classList);

      if (drupalSettings.hasOwnProperty('project_content')) {
        /** @param {Object} **/
        const settings = drupalSettings.project_content;
        const data = settings[paragraph_id];

        if (data.open_in_modal) {
          event.preventDefault();
          console.log(data, 'data from js');

          let markup = document.getElementById('modal-projects-popup-hbs');
          let template = Handlebars.compile(markup.innerHTML);

          let result = template(data);
          let destination = document.getElementById(ModalProjectsDestinationContainer);
          destination.innerHTML = result;
          tryToggleModal('modal-projects-popup');
        }
      }
    });
  });
}

if (paragraphs) {
  const paragraph_arr = Array.from(paragraphs);
  paragraph_arr.forEach(elem => {
    let triggerElem = findTrigger(elem);

    if (!triggerElem) {
      return false;
    }

    triggerElem.addEventListener('click', event => {
      event.preventDefault();

      let paragraph_id;

      let classList = Array.from(triggerElem.classList);
      let paragraph_id_class = classList.find(class_name => class_name.match(/\d+/));
      if (paragraph_id_class) {
        paragraph_id = paragraph_id_class.match(/\d+/)[0];

        if (drupalSettings.hasOwnProperty('leadership_content')) {
          /** @param {Object} **/
          const settings = drupalSettings.leadership_content;
          const data = settings[paragraph_id];

          let markup = document.getElementById('modal-leadership-popup-hbs');
          let template = Handlebars.compile(markup.innerHTML);

          let result = template(data);
          let destination = document.getElementById(ModalDestinationContainer);
          destination.innerHTML = result;
          tryToggleModal();
        }

      }
    });
  });
}



